import {uk} from 'date-fns/locale';
import parseISO from 'date-fns/parseISO';
import format from 'date-fns/format'

export const validateEmail = (email) => {
//	const regExp = /\S+@\S+\.\S+/;
  const regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return email && !regExp.test(email);
};

export const dateTimeToStr = (data) => {
  return data ? format(parseISO(data), 'dd.MM.yyyy HH:mm:ss', {locale: uk}) : "";
};

export const dateToStr = (data) => {
  return data ? format(parseISO(data), 'dd.MM.yyyy', {locale: uk}) : "";
};

export const isInteger = (value) => /^-?\d+$/.test(value);

export const isStringValid = (value) => !!value && !!value.replace(/[&\/\\#,+()$~%.'":*?<>{} ]/g, '');